<template>
	<div>
		<Modal class="InputDisable" v-model="modal.ifShow" :title="modal.Title" width="30%" :mask-closable="false"
			:closable="false">
			<!--控件添加修改-->
			<Form :rules="ruleInline" label-position="right" v-if="modal.type=='view'||modal.type=='up'" ref="refForm"
				:model="modalInfo" :label-width="110">
				<!--放置不需要添加的属性 -->
				<Row v-show="false" :gutter="24">
				</Row>
				<Row :gutter="24">
					<Col span=24>
					<FormItem label="维修说明" prop="RepairDesc">
						<Input :disabled="modal.canInput" v-model="modalInfo.RepairDesc" placeholder="维修说明"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=24>
					<FormItem label="维修详细信息" prop="RepairDetail">
						<Input :disabled="modal.canInput" v-model="modalInfo.RepairDetail" placeholder="维修详细信息"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=24>
					<FormItem label="维修图片" prop="StationCode">
						<div class="demo-upload-list" :key="item.uid" v-for="item in uploadList">
							<template v-if="item.status === 'finished'">
								<img :src="item.url">
								<div class="demo-upload-list-cover">
									<Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
									<Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
								</div>
							</template>
							<template v-else>
								<Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
							</template>
						</div>
						<Upload ref="upload" :headers="upHeader" :show-upload-list="false"
							:default-file-list="defaultList" :on-success="handleSuccess" name="UpFile"
							:format="['jpg','jpeg','png']" :max-size="2048" :on-format-error="handleFormatError"
							:on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple type="drag"
							:action="uploadImageUrl" style="display: inline-block;width:58px;">
							<div style="width: 58px;height:58px;line-height: 58px;">
								<Icon type="ios-camera" size="20"></Icon>
							</div>
						</Upload>
						<Modal title="View Image" v-model="visible" width="75">
							<img :src="imgName" v-if="visible" style="width: 100%">
						</Modal>
					</FormItem>
					</Col>
				</Row>
				<!-- <Row :gutter="24">
					<Col span=24>
					<FormItem label="维修人" prop="RepairUserName">
						<Input :disabled="modal.canInput" v-model="modalInfo.RepairUserName" placeholder="维修人"></Input>
					</FormItem>
					</Col>
				</Row> -->
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="维修开始时间" prop="RepairBeginTime">
						<DatePicker placeholder="维修开始时间" v-model="modalInfo.RepairBeginTime"></DatePicker>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="维修结束时间" prop="RqpairEndTime">
						<DatePicker placeholder="维修结束时间" v-model="modalInfo.RqpairEndTime"></DatePicker>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div v-if="modal.type=='view'" slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">{{ $t('Common.Cancel') }}</Button>
				<Button type="success" size="large" @click="modalOk('add')">确认关单</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	export default {
		data() {
			
			return {
				uploadImageUrl: webapi.base_api_url + '/Common/UploadImage',
				modal: {
					Title: "用户添加",
					type: "add",
					ifShow: false,
					canInput: false
				},
				
				modalInfo: {
					Id: 0,
					Status: 12,
					RepairDesc: "",
					RepairDetail: "",
					RepairPicturesArray: [],
					RepairUser: "",
					RepairBeginTime: "",
					RqpairEndTime: "",
				},
				zindex: 2000,

				//图片上传组件数据
				defaultList: [],
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,
				uploadList: [],
				//新增图片删除缓存，实际点击保存才删除
				PictureDelCache: [],
				//原始图片删除缓存
				PictureUpCache: [],
				/****************/
				// Validate Fields
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					Name: [{
						required: true,
						message: '控件名称',
						trigger: 'blur'
					}],
					Display: [{
						required: true,
						message: '显示名称',
						trigger: 'blur'
					}],
					Icon: [{
						required: true,
						message: '图标',
						trigger: 'blur',
					}],
				},
			};
		},

		methods: {
			
			show: function(type, params) {
				const _this = this;
				if (type == "view") {
					_this.modal.Title = "关单情况填写";
					_this.modal.type = "view";
					_this.modalInfo.Id = params.Id
				}
				_this.modal.ifShow = true
				this.$refs.refForm.resetFields()
			},
			
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						this.cancelPictures()
						break;
					case 'add':
						_this.modal.ifShow = true
						_this.addAndUp('add');
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.addAndUp('up');
						break;
					default:
						break;
				}
			},
		
			addAndUp: function(type) {
				const _this = this;
				_this.$refs.refForm.validate((valid) => {
					console.log("控件" + type + "----" + valid)
					if (valid) {
						let parms = {..._this.modalInfo, }
						_this.$axios.post(webapi.base_api_url + "/Maintenance/SetRepairRecordStatus",
							parms, {}).then(
							res => {
								console.log("关单")
								console.log(res.data)
								if (res.data.Code == 0) {
									this.$Message.success('关单成功');
									_this.$emit('handleSubmit');
									// _this.modalOk("cancle")
									_this.modal.ifShow = false
								} else {
									this.$Message.error(res.data.Msg + "---" + res.data.Data);
								}
							})
					}
				})
			},

			/**********Component Method*********/
			cancelPictures: function() {
				const _this = this
				_this.PictureUpCache = []
				if (_this.PictureDelCache.length > 0) {
					console.log("取消添加或跟新，删除添加的图片")
					let picsArr = _this.PictureDelCache
					let StationPictures = ''
					for (let i = 0; i < picsArr.length; i++) {
						if (i == (picsArr.length - 1)) {
							StationPictures += picsArr[i]
						} else {
							StationPictures += picsArr[i] + ','
						}
					}
					_this.deletePicture(StationPictures)
				}
			},
			deletePicture: function(pictureStr) {
				const _this = this
				_this.$axios.post(webapi.base_api_url + "/Common/DeleteImage", {
					FilePath: pictureStr
				}).then(res => {
					if (res.data.Code == 0) {
						_this.$Message.success('删除未保存图片');
						_this.PictureDelCache = []
						_this.handleSubmit()
					} else {
						_this.$Message.error('图片删除失败');
						_this.handleSubmit()
					}
				})
			},
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('Delete cache ')
				} else {
					console.log('Cache is not exist')
					_this.PictureUpCache.push(file.name)
				}
				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {
					
					console.log(fileList)
					console.log(_this.$refs.upload.fileList)
					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})
				_this.modalInfo.RepairPicturesArray = _this.modalInfo.RepairPicturesArray.filter(function(item, index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					// if (process.env.NODE_ENV === "development") {
					// 	file.url = 'http://' + window.location.href.split("/")[2] + '/ChargePlatform' + res.Data;
					// } else {
					// 	file.url = 'https://' + window.location.href.split("/")[2] + '/ChargePlatform' + res.Data;
					// }
					file.url = webapi.base_api_url + res.Data.List[0];
					file.name = res.Data.List[0];
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.modalInfo.RepairPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: this.$t('Common.FormatError'),
					desc: this.$t('Common.SelectJpgOrPng')
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: this.$t('Common.ImageTooLarge'),
					desc: this.$t('Common.File') + file.name + ' '+this.$t('Common.SelectSmallerImg')
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
		},
		mounted() {
			this.upHeader.Authorization = "Bearer " + encodeURIComponent(localStorage.AccessToken);
		},
		computed: {
			
			...mapState({
				StationList: 'Stations',
				RoleList: 'roleList',
				OperatortypeList: 'typeList'
			}),
		}
	}
</script>

<style>
	.InputDisable .ivu-input[disabled],
	fieldset[disabled] .ivu-input {
		background-color: #cccccc !important;
		opacity: 0.5;
		cursor: not-allowed;
		color: #000000;
		font-weight: bold;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
